import React, { useEffect, useState } from "react";

export const GamePlayer = () => {
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const BASE_W = 700;
        const BASE_H = 500;

        const updateScale = () => {
            const scaleX = window.innerWidth / BASE_W;
            const scaleY = window.innerHeight / BASE_H;

            setScale(Math.min(scaleX, scaleY) * 0.95);
        };

        updateScale();
        window.addEventListener("resize", updateScale);

        return () => window.removeEventListener("resize", updateScale);
    }, []);

    return (
        <div
            style={{
                position: "relative",
                height: "100%", 
                inset: 0,
                background: "radial-gradient(circle,#1E3A5F 0%, #000000 100%)",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    position: "relative",
                    top: "520px",
                    left: "900px",
                    width: "800px",
                    height: "750px",
                    transform: `translate(-50%, -50%) scale(${scale})`,
                    transformOrigin: "center center",
                }}
            >
                <iframe
                    src="https://openhtml5games.github.io/games-mirror/dist/mariohtml5/main.html"
                    title="Mario"
                    style={{
                        width: "800px",
                        height: "600px",
                        border: "none",
                        display: "block",
                    }}
                />
            </div>
        </div>
    );
};